module.exports = __webpack_public_path__ + "4aac093ab17e0481af20087cceeb36bb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/fannie_mae_2022_chart.png
// module id = 1672
// module chunks = 0